import { render, staticRenderFns } from "./RaceEdit.vue?vue&type=template&id=48e5fee6&scoped=true&"
import script from "./RaceEdit.vue?vue&type=script&lang=js&"
export * from "./RaceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5fee6",
  null
  
)

export default component.exports